<template>
    <div>
        <banner-list-link :listLayout="listLayout" :bannerData="bannerData"></banner-list-link>
    </div>
</template>

<script>
import BannerListLink from "@/components/banner/BannerListLink";
import bannerUtil from "@/components/banner/bannerUtil";


import alertMixins from "@/mixins/alertMixins";
import DeleteClass from "@/mixins/deleteClass";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import awsS3FileUpload from "@/mixins/awsS3FileUpload";

export default {
    name: "BannerListComponent",
    mixins: [bannerUtil, alertMixins, awsS3FileUpload],
    components: {
        BannerListLink
    },
    inject: [],
    provide() {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
            bannerListDelete: this.runDeleteConfirm,
            writeBanner: this.writeBanner

        }
    },
    props: {
        bannerType: {default: ''},
    },
    data() {
        return {
            listLayout: '',
            filterLayout: '',
            paginationLayout: '',
            getFunc: '',
            listApiParamSet: {},

            bannerData: [],
            files: [],

            //delete data
            deleteFunc: '',
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            keyName: '',
            DeleteClass: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initConfig();
    },
    mounted() {
        EventBus.$on('addBannerData', this.addBannerData)
    },
    beforeDestroy() {
        EventBus.$off('addBannerData')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initConfig() {
            let config = this.returnBannerConfig(this.bannerType)
            this.listLayout = config.listLayout;
            this.filterLayout = config.filterLayout;
            this.paginationLayout = config.paginationLayout;
            this.getFunc = config.getFunc;
            this.listApiParamSet = config.listApiParamSet
            // let listOptions = {
            //     url: this.$api.$banner[this.getFunc],
            //     defaultParams: this.listApiParamSet,
            // }
            this.getBanner()

            this.deleteFunc = config.deleteFunc
            this.deleteApiParamsSet = config.deleteApiParamsSet
            this.deleteSuccessType = config.deleteSuccessType
            this.deleteFailTypes = config.deleteFailTypes
            this.deleteKeyName = config.deleteKeyName
            this.newDeleteClass();

        },
        getBanner() {
            this.bannerData = []
            let params = this.listApiParamSet
            try {
                this.$api.$banner[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type == 1) {
                        this.bannerData = res.List
                        util.Array.each(this.bannerData, (banner, index, arr) => {
                            banner.deleteFiles = []
                        })
                    } else {
                        this.bannerData = []

                    }
                })
            } catch (e) {
                console.log(e)
            }

        },
        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$banner[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.deleteKeyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                }
                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },
        runDeleteConfirm(key, idx) {
            this.createConfirm({
                content: '정말 삭제하시겠습니까?',
                confirm: () => {
                    this.runDelete(key);
                }
            })
        },
        runDelete(key) {
            EventBus.$emit('changeLoading', true)
            this.DeleteClass.runDelete(key);
        },
        deleteAfterFunc() {
            EventBus.$emit('changeLoading', false)

            this.createAlert({
                content: '삭제되었습니다.',
                hide: () => {
                    EventBus.$emit('removeBannerFilterDate')
                    this.getBanner()
                }
            })
        },
        setData(key, value) {
            this[key] = value
        },
        writeBanner(params, writeFunc) {
            this.files = params.Files;
            this.mobileFiles = params.MobileFiles;
            if (!util.isEmpty(params.deleteFiles)) {
                this.runS3ApiDeleteFiles(params.deleteFiles)
            }
            delete params.Files;
            delete params.Pc;
            delete params.Mobile;
            delete params.deleteFiles

            try {
                this.$api.$banner[writeFunc](params).then(res => res.Data.Result).then(res => {
                    let type = this.returnWriteBannerType(res.Info.type)
                    if (type === true) {
                        let key = ''
                        key = params.hasOwnProperty('b_idx') ? params.b_idx : res.List.b_idx
                        this.uploadImage(key)
                    } else {
                        this.errorAlert(type)
                    }
                })
            } catch (e) {
                console.log(e)
            }
        },
        returnWriteBannerType(type) {
            switch (type) {
                case 1 :
                    return true
                case -701:
                    return '노출개수가 초과되었습니다.'
                default :
                    return "저장에 실패하였습니다."

            }

        },
        uploadImage(id) {
            let fileInfo = [
                {
                    fileName: 'files',
                    fileType: 'banner',
                },
                {
                    fileName: 'mobileFiles',
                    fileType: 'bannerMobile',
                }]

            let pcCheckFile = !util.isEmpty(this.files) && this.files.filter(file => file.hasOwnProperty('raw')).length > 0;
            let mobileCheckFile = !util.isEmpty(this.mobileFiles) && this.mobileFiles.filter(file => file.hasOwnProperty('raw')).length > 0;
            let checkFile = pcCheckFile || mobileCheckFile;
            if (checkFile) {
                this.runUploadFileInfo(fileInfo, 0, id).then(res => {

                    this.createAlert({
                        content: '저장되었습니다.',
                        hide: () => {
                            EventBus.$emit('apiLoading', false);
                            this.getBanner()
                        }
                    })
                })
            } else {
                this.createAlert({
                    content: '저장되었습니다.',
                    hide: () => {
                        EventBus.$emit('apiLoading', false);
                        this.getBanner()
                    }
                })
            }
        },
        addBannerData() {
            this.bannerData.unshift({
                Files: [],
                MobileFiles: [],
                deleteFiles: [],
                b_type: 'image',
                b_is_display: 0,
                b_url: '',
                b_key: '',
                b_subject: '',
                b_seq: 0,
                period_date: []
            })
            EventBus.$emit('setBannerFilterDate', []);
        }

    },
    watch: {
        'bannerData': {
            deep: true,
            handler: function (val, oldVal) {
                EventBus.$emit('topBannerAddBtn', this.bannerData)
            }
        }
    },
}
</script>

<style scoped>

</style>
